import {
    Component,
    Input,
    Output,
    EventEmitter,
    HostBinding
} from '@angular/core';

@Component({
    selector: 'app-decoration-settings',
    templateUrl: './decoration-settings.component.pug',
    styleUrls: ['./decoration-settings.component.less']
})
export class DecorationSettingsComponent {
    public isLocationAvailable = false;
    public isSizeAvailable = false;
    public isRotationAvailable = false;
    public isFlipAvailable = false;

    _settings: IDecorationSettings  = {};
    @Input() set settings(settings) {
        this._settings = settings;

        this.isLocationAvailable = settings.hasOwnProperty('x') && settings.hasOwnProperty('y');
        this.isSizeAvailable = settings.hasOwnProperty('width') && settings.hasOwnProperty('height');
        this.isRotationAvailable = settings.hasOwnProperty('rotation');
        this.isFlipAvailable = settings.hasOwnProperty('flip');
    }
    get settings() {
        return this._settings;
    }
    @Input() disabled: boolean = false;
    @HostBinding('class.--disabled') get _disabled() {
        return this.disabled;
    }
    get settingsRotation() {
        return this.settings.rotation / Math.PI * 180;
    }

    get settingsWidth() {
        return this.settings.width;
    }

    @Output() back: EventEmitter<any> = new EventEmitter();
    @Output() flip: EventEmitter<any> = new EventEmitter();
    @Output() width: EventEmitter<any> = new EventEmitter();
    @Output() rotation: EventEmitter<any> = new EventEmitter();
    @Output() activate: EventEmitter<any> = new EventEmitter();

    constructor(
    ) {
    }

    onBack() {
        this.back.emit();
    }

    onFlip() {
        this.flip.emit(true);
    }

    onChange(name, value) {
        this[name].emit(Number(value));
    }

    onActivate() {
        this.activate.emit();
    }
}
